<!-- IconPreviousArtwork.vue - "Use My Previous Artwork" icon (clock/history) -->
<template>
  <svg 
    width="35" 
    height="35" 
    viewBox="0 0 30 30" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    class="icon-previous-artwork"
  >
    <path 
      d="M14.5833 26.25C17.6775 26.25 20.645 25.0208 22.8329 22.8329C25.0208 20.645 26.25 17.6775 26.25 14.5833C26.25 11.4891 25.0208 8.52168 22.8329 6.33375C20.645 4.14583 17.6775 2.91667 14.5833 2.91667C11.4891 2.91667 8.52168 4.14583 6.33375 6.33375C4.14583 8.52168 2.91667 11.4891 2.91667 14.5833C2.91667 17.6775 4.14583 20.645 6.33375 22.8329C8.52168 25.0208 11.4891 26.25 14.5833 26.25ZM14.5833 0C16.4984 0 18.3948 0.377209 20.1641 1.11009C21.9335 1.84297 23.5411 2.91717 24.8953 4.27136C26.2495 5.62555 27.3237 7.2332 28.0566 9.00253C28.7895 10.7719 29.1667 12.6682 29.1667 14.5833C29.1667 18.4511 27.6302 22.1604 24.8953 24.8953C22.1604 27.6302 18.4511 29.1667 14.5833 29.1667C6.51875 29.1667 0 22.6042 0 14.5833C0 10.7156 1.53645 7.00626 4.27136 4.27136C7.00626 1.53645 10.7156 0 14.5833 0ZM15.3125 7.29167V14.9479L21.875 18.8417L20.7812 20.6354L13.125 16.0417V7.29167H15.3125Z" 
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconPreviousArtwork'
};
</script>

<style scoped>
.icon-previous-artwork {
  display: block;
}
</style>
